import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter, Inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { interval, Observable, Subject } from "rxjs";
import { delayWhen, tap } from 'rxjs/operators';
import { NgIf, NgClass, AsyncPipe, DOCUMENT } from '@angular/common';

@Component({
    selector: 'kb-side-tray',
    templateUrl: './side-tray.component.html',
    styleUrls: ['./side-tray.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        AsyncPipe,
    ],
})
export class SideTrayComponent implements OnInit, OnChanges {
    @Input() trayClasses = '';
    @Input() expanded = false;
    @Input() title = '';
    @Output() close = new EventEmitter();

    open$: Observable<boolean>;
    private _open$ = new Subject<boolean>();

    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    ngOnInit() {
        this.open$ = this._open$.pipe(delayWhen((isOpen) => interval(isOpen ? 0 : 300)),
            tap(isOpen => {
                const root = this.document.documentElement;
                // Take advantage of the same mechanism used by the Angular
                // CDK to prevent page scrolling when an oerlay is being
                // displayed.
                if (isOpen) {
                    root.classList.add('cdk-global-scrollblock');
                } else {
                    root.classList.remove('cdk-global-scrollblock');
                }
            }));
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('expanded' in changes) {
            this._open$.next(changes['expanded'].currentValue);
        }
    }
}
